module.exports = __webpack_public_path__ + "img/Kundetelling_logo_2019.dec32fd9.png";